// extracted by mini-css-extract-plugin
export default {"elements":"HXadOB","button":"P_1ikW","checkIcon":"ZV4ewc","submittedMessageContainer":"SMV72x"};